import React, { ChangeEvent, FC } from 'react'
import { Card, CardInner } from 'components/Card'
import { SubCaution, SubDescription, SubHeadline } from 'components/Typography'
import { Spacer } from 'components/Utility'
import { DayOfWeekType } from 'lib/daysOfWeek'
import { FlexRow } from 'components/Flex'
import { SelectDaysOfWeekButton } from 'components/Button'
import equal from 'fast-deep-equal'
import { DaysOfWeekPicker } from 'components/Form'

type Props = {
  holidays: DayOfWeekType[]
  handleHolidays: (event: ChangeEvent<HTMLInputElement>) => void
  selectableDaysOfWeek: DayOfWeekType[]
  selectAll: () => void
  unselectAll: () => void
}

const HolidayCard: FC<Props> = React.memo(
  (props) => {
    const { holidays, handleHolidays, selectableDaysOfWeek, selectAll, unselectAll } = props

    return (
      <Card disabled={selectableDaysOfWeek.length === 0}>
        <CardInner>
          <FlexRow justifyContent={'between'}>
            <SubHeadline headline={'定休日'} required={true} />
            <SelectDaysOfWeekButton daysOfWeek={holidays} selectAll={selectAll} unselectAll={unselectAll} />
          </FlexRow>
          <Spacer size={8} />
          <SubDescription description={'商品の注文を受け付けない曜日を選択してください'} />
          <SubCaution
            caution={
              '※変則的な休業日（第二土曜日など）はトップページのカレンダーの「臨時休業日」を設定するから選択してください。'
            }
          />
          <Spacer size={16} />
          <DaysOfWeekPicker
            daysOfWeek={holidays}
            onChange={handleHolidays}
            selectableDaysOfWeek={selectableDaysOfWeek}
            wrap={false}
          />
        </CardInner>
      </Card>
    )
  },
  (prev, next) => equal(prev, next)
)

export default HolidayCard
